import { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { ease } from "./Reveal";

const OPS = [
  ["telkomsel", "Telkomsel"],
  ["xl_axis", "XL Axis"],
  ["three", "Three"],
  ["indosat", "IM3"],
  ["smartfren", "Smartfren"],
];

const Coin = ({ k, label, innerRef }) => (
  <div ref={innerRef} className="absolute left-1/2 top-1/2 will-change-transform" data-testid={`hero-coin-${k}`}>
    <div className="coin grid h-[72px] w-[72px] place-items-center rounded-full sm:h-24 sm:w-24">
      <div className="grid h-[80%] w-[80%] place-items-center rounded-full bg-white shadow-inner">
        <img src={`/img/ops/${k}.webp`} alt={label} className="h-[78%] w-[78%] object-contain" />
      </div>
    </div>
  </div>
);

export const HeroVisual = () => {
  const box = useRef(null);
  const coins = useRef([]);
  const pointer = useRef({ x: 0, y: 0 });

  useEffect(() => {
    let raf;
    const onMove = (e) => {
      pointer.current = { x: e.clientX / window.innerWidth - 0.5, y: e.clientY / window.innerHeight - 0.5 };
    };
    const tick = (t) => {
      const el = box.current;
      if (el) {
        const w = el.offsetWidth, h = el.offsetHeight;
        const rx = w * 0.44, ry = h * 0.13;
        coins.current.forEach((c, i) => {
          if (!c) return;
          const a = t * 0.00035 + (i / OPS.length) * Math.PI * 2;
          const depth = Math.sin(a);
          const s = 0.72 + (depth + 1) * 0.2;
          const x = Math.cos(a) * rx + pointer.current.x * 30;
          const y = depth * ry + h * 0.05 + Math.sin(t * 0.0012 + i) * 8 + pointer.current.y * 20;
          c.style.transform = `translate(-50%,-50%) translate(${x}px,${y}px) scale(${s}) rotateY(${Math.cos(a) * 40}deg)`;
          c.style.zIndex = depth > 0 ? "30" : "5";
          c.style.filter = depth > 0 ? "none" : `blur(${(1 - (depth + 1)) * 1.5}px) brightness(0.7)`;
        });
      }
      raf = requestAnimationFrame(tick);
    };
    window.addEventListener("pointermove", onMove);
    raf = requestAnimationFrame(tick);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("pointermove", onMove);
    };
  }, []);

  return (
    <div ref={box} className="relative h-full w-full [perspective:900px]" data-testid="hero-visual">
      <div className="absolute left-1/2 top-[46%] h-[70%] w-[70%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-volt/25 blur-[90px]" />
      <div className="absolute left-1/2 top-[52%] h-[46%] w-[86%] -translate-x-1/2 -translate-y-1/2 rounded-[50%] border border-volt/25" style={{ transform: "translate(-50%,-50%) rotateX(72deg)" }} />
      <motion.img
        src="/img/hero-woman-cut.webp"
        alt="Wanita berhijab terkejut senang memegang HP"
        initial={{ opacity: 0, scale: 1.08, y: 30 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 1.4, ease, delay: 0.2 }}
        className="hero-woman relative z-10 mx-auto h-full w-auto object-contain object-bottom"
      />
      {OPS.map(([k, label], i) => (
        <Coin key={k} k={k} label={label} innerRef={(el) => (coins.current[i] = el)} />
      ))}
    </div>
  );
};
